




























































































































































































































































import {ErrorPeriod, PeriodsData, StatusPeriod, SystemNode} from '@/components/system/interfaces';
import {Component, Vue, Model, Prop, Watch} from 'vue-property-decorator';
import SegmentBarDiagram from '@c/diagrams/SegmentBarDiagram.vue';
import {SegmentBarDiagramItem} from '@/components/diagrams/interfaces';
import {requestFullThree} from '@/api/nodeApi';
import {MachineWorkingStatus, SystemNodeType} from '@/components/system/enums';
import {fsStatusDiagramColorScheme as colorScheme} from '@/components/system/configurate';
import Loading from '@c/controls/Loading.vue';
import {DateTime} from 'luxon';
import {httpClient} from '@/api/baseApi';
import userSettingsModule from '@/store/modules/userSettingsModule';

@Component({
  components: {SegmentBarDiagram, Loading},
})
export default class FacilityStructureTree extends Vue {
  // Модель выбранного пути для дерева
  @Model('change') selectedNodesPath!: SystemNode[];

  get changeSelectedNodePath() {
    return this.selectedNodesPath;
  }

  set changeSelectedNodePath(newSelectedNodesPath: SystemNode[]) {
    this.$emit('change', newSelectedNodesPath);
  }

  @Watch('selectedNodesPath')
  onSelectedNodesPath(newValue: SystemNode[]) {
    if (newValue.length && newValue[newValue.length - 1].type !== SystemNodeType.MachineUnit)
      //TODO:
      this.activeItems = [newValue[newValue.length - 1]];
  }

  @Prop()
  selectedNodes!: string[];

  @Prop()
  showWeekWorkload!: boolean;

  @Prop()
  showDayWorkload!: boolean;

  @Prop()
  showNodeNumbers!: boolean;

  @Prop()
  moduleType?: string;

  async updateTree(customDayWorkload: any, customWeekWorkload: any) {
    try {
      this.loading = true;
      await this.addWorkloadToObjects(customDayWorkload, customWeekWorkload);
    } catch (e) {
      console.log('Error on request Facility Nodes, ', e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // при изменении selectedNodeId в настройках, фильтровать(обрезать) дерево
  @Watch('selectedNodes')
  async onSelectedNodeId(newValue: string[]) {
    const nodes = this.nodesTree;
    if (nodes?.length != 0 && newValue && this.newNodesArray?.length != 0) {
      this.loading = true;
      await this.cutTreeBySelectedNodes(newValue);
      this.rerender = true;
      this.loading = false;
    }
  }

  @Watch('openNewNodes')
  onOpenNodesChange(newValue: any) {
    if (this.firstOpen) this.firstOpen = false;
    else {
      const settings = {
        dashboard: newValue,
        nodesTree: this.openNodesStorage ? this.openNodesStorage.nodesTree : null,
      };
      userSettingsModule.setOpenNodes(settings);
    }
  }

  @Watch('activeItems')
  onActiveItemsChange(newValue: any) {
    userSettingsModule.setActiveNode(newValue);
  }

  @Watch('moduleType')
  onModuleTypeChange(newValue: string) {
    this.sourceModelType = newValue;
  }

  // Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Цвета для основных сегментов диаграммы (неделя)
  weekMainSegmentsColors = [
    colorScheme.week.status.off,
    colorScheme.week.status.idle,
    colorScheme.week.status.work,
    colorScheme.week.status.incorrect,
  ];

  // Цвета для основных сегментов диаграммы (день)
  dayMainSegmentsColors = [
    colorScheme.day.status.off,
    colorScheme.day.status.idle,
    colorScheme.day.status.work,
    colorScheme.day.status.incorrect,
  ];

  // Цвета для дополнительных сегментов диаграммы (неделя)
  weekAdditionalSegmentsColors = [colorScheme.week.error];

  // Цвета для дополнительных сегментов диаграммы (день)
  dayAdditionalSegmentsColors = [colorScheme.day.error];

  // Показатели загрузки данных и наличия ошибок при загрузке данных
  loading = true;
  error = false;

  rerender = false;

  firstIdInTree!: string[];

  openNodesStorage: any = null;

  firstOpen = true;

  sourceModelType: string | null = null;

  //TODO: сейчас округляю все данные к целому
  roundValue(value: number) {
    return Math.floor(value);
  }

  // Получение границ диаграммы
  getXBounds(data: PeriodsData) {
    return {min: data.startDate, max: data.endDate};
  }

  // Получение сегментов по статусам работы станка
  getTransformedStatusSegments(statusPeriods: StatusPeriod[]): SegmentBarDiagramItem[] {
    if (!statusPeriods) return [];
    return statusPeriods.map(x => ({
      start: x.start,
      end: x.end,
      mode: x.unstatus as number,
    }));
  }

  // Получение сегментов ошибок работы станка
  getTransformedErrorSegments(errorPeriods: ErrorPeriod[]): SegmentBarDiagramItem[] {
    return errorPeriods
      .filter(x => x.exists)
      .map(x => ({
        start: x.start,
        end: x.end,
        mode: 0,
      }));
  }

  // Элементы дерева
  items: SystemNode[] = [];

  // преобразованные элементы дерева
  nodesArray: SystemNode[] = [];

  // преобразованные элементы дерева (c загруженностью (поле data))
  newNodesArray: SystemNode[] = [];

  // дерево структуры предприятий (c загруженностью (поле data))
  nodesTree: SystemNode[] = [];

  // итоговый массив структуры предприятий (после применения настроек)
  nodesBySettings: SystemNode[] = [];

  // Открытые элементы дерева для newNodesArray
  openNewNodes: SystemNode[] = [];

  // Открытые элементы дерева из localStorage
  openNodes: SystemNode[] | null = null;

  // Выбранные элементы дерева (для компоненты)
  activeItems: SystemNode[] = [];

  firstRequest = 0;

  boundaries = [];

  getBoundaries() {
    return this.boundaries;
  }

  getNodeColor(currentBoundary: any) {
    if (currentBoundary == -3) return 'purple';
    else if (currentBoundary == -2) return 'blue';
    else if (currentBoundary == -1) return 'cyan';
    else if (currentBoundary == 0) return 'green';
    else if (currentBoundary == 1) return 'yellow';
    else if (currentBoundary == 2) return 'orange';
    else if (currentBoundary == 3) return 'red';
    else return '';
  }

  async created() {
    try {
      const openNodes = localStorage.getItem('openNodes');
      if (openNodes) {
        this.openNodesStorage = JSON.parse(openNodes);
        this.openNodes = this.openNodesStorage.dashboard;
      }
      this.items = await requestFullThree(); //загружаем полное дерево структуры предприятия

      if (this.selectedNodes && this.selectedNodes.length) {
        this.firstIdInTree = [];
        this.firstIdInTree.push(this.items[0].id);
        this.nodesBySettings = [];
        let oldTree = [];
        oldTree = this.items;
        for (const item of this.items) {
          this.findSomeNodesInTree(item, this.selectedNodes); //сразу обрезаем согласно установленным настройкам
        }
        this.nodesTree = this.nodesBySettings.length == 0 ? oldTree : this.nodesBySettings;
        this.items = this.nodesTree;
      } else {
        this.nodesTree = this.items;
      }
      if (!this.openNewNodes.length) {
        if (this.openNodes) this.openNewNodes = this.openNodes;
        else if (this.nodesTree.length) this.openNewNodes = [this.nodesTree[0]];
      }
      const activeItems = localStorage.getItem('activeNode');
      if (activeItems) this.activeItems = JSON.parse(activeItems);
      await this.addWorkloadToObjects(); // создаем массив из дерева и для каждого объекта(узла) подгружаем загруженность
    } catch (e) {
      console.log('Error on request Facility Nodes, ', e);
      this.error = true;
    } finally {
      this.loading = false;
      this.setTimerToUpdateData();
    }
  }

  timer: any = null;

  setTimerToUpdateData() {
    this.timer = setInterval(async () => {
      await this.addWorkloadToObjects();
    }, 300000);
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  // Найти путь от корня дерева до элемента с id
  getPathByNodeId(id: string): SystemNode[] {
    const stack = [...this.items];
    const prev: Record<string, SystemNode> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: SystemNode[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id]) {
          node = prev[node.id];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          prev[c.id] = x;
          stack.push(c);
        });
    }
    return [];
  }

  // Действия при выборе узла в дереве
  onUpdateActive(e: any) {
    if (e && e.length > 0) this.changeSelectedNodePath = this.getPathByNodeId(e[0].id);
    else this.changeSelectedNodePath = [];
  }

  async addWorkloadToObjects(customDayWorkload: any = null, customWeekWorkload: any = null) {
    const dayWorkload = customDayWorkload != null ? customDayWorkload : this.showDayWorkload;
    const weekWorkload = customWeekWorkload != null ? customWeekWorkload : this.showWeekWorkload;

    this.newNodesArray = [];
    this.firstRequest = 0;
    this.items.forEach((item: any) => {
      this.buildArrayFromTree(item, null, this.firstRequest);
    });

    const date = Date.now();
    const startDateD = Math.floor(
      DateTime.fromMillis(date)
        .minus({['days' as string]: 1})
        .valueOf(),
    );
    const startDateW = Math.floor(
      DateTime.fromMillis(date)
        .minus({['week' as string]: 1})
        .valueOf(),
    );
    const endDate = date;

    this.boundaries = [];

    const firstNodeId = this.nodesArray[0].id;

    let dataD: any[] = [];
    let dataW: any[] = [];
    for (const node of this.items) {
      dataD = dataD.concat(
        dayWorkload
          ? await this.getData(node.id, startDateD, endDate, true)
          : await this.getData(node.id, startDateD, endDate, false),
      );
      dataW = dataW.concat(
        weekWorkload ? await this.getData(firstNodeId, startDateW, endDate, true) : [],
      );
    }

    for (const node of this.nodesArray) {
      const dayData = dataD?.find((x: any) => x.id == node.id);
      const weekData = dataW?.find((x: any) => x.id == node.id);
      const object = this.fillSystNodeWithWorkload(
        node,
        dayData,
        weekData,
        startDateD,
        startDateW,
        endDate,
      );
      this.newNodesArray.push(object);
      this.nodesTree = this.makeTreeFromArray(this.newNodesArray, null);
    }
  }

  async getData(nodeId: any, startDate: any, endDate: any, addWorkload: any) {
    const {data} = await httpClient.get(`/services/workload/${nodeId}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        add_workload: addWorkload,
        module_type: this.moduleType,
      },
    });
    return data;
  }

  // формируем массив узлов из дерева для удобства дальнейшей работы с узлами ( для подгрузки загруженности)
  buildArrayFromTree(item: any, parentId: any = null, firstRequest: any) {
    if (firstRequest == 0) this.nodesArray = [];
    item.parentId = parentId;
    if (this.showNodeNumbers) item.fullName = item.id + '.' + item.name;
    else item.fullName = item.name;
    this.nodesArray.push(item);
    if (item.children) {
      item.children.forEach((child: any) => this.buildArrayFromTree(child, item.id, 1));
    }
    this.firstRequest++;
  }

  // подгружаем загруженность узла (за день/неделю) и создаем новый элемент, который добавляем в новый массив узлов (с загруженностью)
  fillSystNodeWithWorkload(
    node: any,
    dataDay: any,
    dataWeek: any,
    startDateD: any,
    startDateW: any,
    endDate: any,
  ) {
    const dataD = this.loadWorkload(startDateD, endDate, dataDay);
    const dataW = this.loadWorkload(startDateW, endDate, dataWeek);

    const systemNodeData = {
      productionDay: dataD.productionData,
      productionWeek: dataW.productionData,
    };

    const obj = {
      id: node.id, //  Идентификатор узла
      parentId: node.parentId,
      name: node.name, // Наименование узла
      fullName: node.fullName,
      children: node.children, // Список узлов-потомков //TODO: Предполагаю, что все дерево разом будет грузиться с сервера
      type: node.type, // Тип узла
      coords: node.coords, // Координаты узла на мнемосхеме
      data: systemNodeData, // загруженность
      currentBoundary: dataD.currentBoundary,
    };

    (this.boundaries as any).push({id: node.id, boundary: dataD.currentBoundary});

    return obj;
  }

  // заполняем интерфейс загруженности
  loadWorkload(startDate: number, endDate: number, data: any) {
    // рассчитываем часы и проценты загруженности
    let hours = null;
    if (!data || !data?.machine_status_events) hours = this.calcHours([]);
    else hours = this.calcHours(data?.machine_status_events);
    const percent = (hours / (endDate - startDate)) * 100;
    hours = hours / (3600 * 1000);
    const errorsSum = data?.boundaries;
    const currentBoundary = data?.current_boundary;

    // заполняем объекты для создания массива структур
    const periodsData = {
      startDate: startDate,
      endDate: endDate,
      errorPeriods: [],
      statusPeriods: data?.machine_status_events,
    };

    const productionData = {
      errorsCount: errorsSum,
      percent: percent,
      hours: hours,
      periodsData: periodsData,
    };

    return {productionData, currentBoundary};
  }

  // рассчитываем часы загруженности
  calcHours(machineStatusEvents: StatusPeriod[]) {
    const workEvents = machineStatusEvents.filter(
      (event: StatusPeriod) =>
        event.unstatus != MachineWorkingStatus.Off &&
        event.unstatus != MachineWorkingStatus.Incorrect,
    );
    const hours = workEvents.reduce((acc, event) => acc + (event.end - event.start), 0);

    return hours;
  }

  // формируем дерево из нового массива узлов (с загруженностью)
  makeTreeFromArray(newNodesArray: any[], parentId: any): SystemNode[] {
    const sortByTitle = function(d1: any, d2: any) {
      return d1.id > d2.id ? 1 : -1;
    };
    return newNodesArray
      .sort(sortByTitle)
      .filter(node => node.parentId === parentId)
      .map(child => ({...child, children: this.makeTreeFromArray(newNodesArray, child.id)}));
  }

  // выборка узлов дерева по установленным настройкам отображения структуры предприятия
  findSomeNodesInTree(node: any, newValue: any[]) {
    if (node) {
      const startIds = newValue?.length ? newValue : this.firstIdInTree;
      //если id узла есть в массиве id, добавляем узел в список узлов и выходим
      const res = startIds?.some((x: string) => x == node.id);
      if (res) {
        this.nodesBySettings.push(node);
      }
      // если не найден узел в полученном списке, то идем вглубь
      else {
        node.children.forEach((child: any) => this.findSomeNodesInTree(child, startIds));
      }
    }
  }

  async cutTreeBySelectedNodes(newValue: string[]) {
    this.nodesBySettings = [];
    let oldTree = [];

    this.items = await requestFullThree(); //подгружаем полное дерево

    for (const item of this.items) {
      this.findSomeNodesInTree(item, newValue); //сразу обрезаем согласно установленным настройкам
    }

    oldTree = this.items;
    this.items = this.nodesBySettings.length == 0 ? oldTree : this.nodesBySettings;

    await this.addWorkloadToObjects();

    this.changeSelectedNodePath = [];
    this.openNewNodes = [this.nodesTree[0]];
    this.rerender = !this.rerender;
  }
}
